import React, { useState } from 'react';
import { youtubeVideos } from '../mock';
import { Play, Youtube } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent } from './ui/dialog';

const Videos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <section id="videos" className="py-20 bg-gradient-to-b from-black to-zinc-900 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Watch & Learn: <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">Pro Detailing in Action</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Get an inside look at our process and expertise
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {youtubeVideos.map((video, index) => (
            <div
              key={video.id}
              className="group relative cursor-pointer transform hover:scale-105 transition-all duration-500"
              style={{ animationDelay: `${index * 100}ms` }}
              onClick={() => setSelectedVideo(video)}
            >
              {/* Thumbnail */}
              <div className="relative rounded-xl overflow-hidden shadow-xl">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full aspect-video object-cover group-hover:scale-110 transition-transform duration-500"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300"></div>
                
                {/* Play Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center group-hover:scale-125 transition-transform duration-300 shadow-lg">
                    <Play className="w-8 h-8 text-white fill-white ml-1" />
                  </div>
                </div>

                {/* YouTube Badge */}
                <div className="absolute top-4 right-4 bg-red-600 px-3 py-1 rounded-full flex items-center gap-1">
                  <Youtube className="w-4 h-4 text-white" />
                  <span className="text-white text-xs font-bold">YouTube</span>
                </div>
              </div>

              {/* Video Title */}
              <h3 className="mt-4 text-white font-semibold group-hover:text-orange-500 transition-colors duration-300 line-clamp-2">
                {video.title}
              </h3>
            </div>
          ))}
        </div>

        {/* Subscribe CTA */}
        <div className="mt-16 text-center">
          <Button
            size="lg"
            className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-6 text-lg rounded-md transform hover:scale-105 transition-all duration-300 shadow-xl"
            onClick={() => window.open('https://www.youtube.com/@bossdetailingpros', '_blank')}
          >
            <Youtube className="w-6 h-6 mr-2" />
            Subscribe for More Tips
          </Button>
        </div>
      </div>

      {/* Video Modal */}
      <Dialog open={!!selectedVideo} onOpenChange={() => setSelectedVideo(null)}>
        <DialogContent className="max-w-4xl w-full bg-zinc-900 border-zinc-700">
          {selectedVideo && (
            <div className="aspect-video">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg"
              ></iframe>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Videos;
